<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_DEFAULT_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-4">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :pageId="this.$options.name"
              :selectedMd="frame1.selectData.COD_MDLE"
              :selectedSmd="frame1.selectData.COD_SMDLE"
              :customMdList="optionCodes.selOption"
              :customSmdList="optionCodes.selOption"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_ID')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              ref="programId"
              v-model="frame1.programId"
              :clearable="true"
              :readonly="false"
              maxlength="100"
              @keyup.enter="onPrgIdValidCheck"
              @keyup="onKeyUpInput"
            />
            <div class="comp_spacing" />
            <sui-button
              type="button"
              class="comm_btn_duplicate"
              :disabled="programIdCheckFlag"
              @click="onPrgIdValidCheck"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_NM')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model="frame1.programName"
              :disabled="false"
              :clearable="true"
              :readonly="false"
              maxlength="100"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_TYPE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-4">
            <sui-code-select
              ref="comboPrgType"
              :selected="frame1.selectData.COD_PRG_TYPE"
              :pageId="this.$options.name"
              codeId="COD_PRG_TYPE"
              :defaultOption="'select'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_TECHN')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-4">
            <sui-code-select
              ref="comboPrgTechn"
              :selected="frame1.selectData.COD_PRG_TECHN"
              :pageId="this.$options.name"
              codeId="COD_PRG_TECHN"
              :defaultOption="'select'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-4">
            <sui-radio
              v-model="frame1.selectData.useYn"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame1.selectData.useYn"
              value="N"
            >
              No
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_CNTN')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model="frame1.programContents"
              :disabled="false"
              maxlength="1000"
            />
          </div>
        </div>
      </div>

      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_FILE_INFO') }}</h4>
      </div>
      <sui-grid
        ref="grdfilelist"
        :columns="gridColumns0"
        :dataset="'dsFileLst'"
        :showDisplayCountControl="false"
        :enabletooltips="true"
        :initialPagesize="5"
        :multiselect="true"
      >
        <div class="comp_spacing" />
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickAddRow"
          >
            {{ $t('MSG_BTN_ROW_ADD') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickDelRow"
          >
            {{ $t('MSG_BTN_ROW_DEL') }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_ATTH_FILE') }}</h4>
      </div>
      <cmp-file-attacher
        ref="fileAttacher"
        :pageId="pageId"
        :showAddDeleteBtn="true"
        :showUpDownArrowBtn="true"
        :attachGroupId="attachGroupId"
        :attachDocumentId="attachDocumentId"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancelClick"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        v-permission:create="'PGE_CMS_00006'"
        type="button"
        class="comm_btn_solid"
        @click="onSaveClick"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

// const CODE_KEYS = ['COD_PRG_FILE_TYPE', 'COD_DTSVC_USE_YN'];
const CODE_KEYS = ['COD_PRG_FILE_TYPE'];
const gridEditorFactory = utils.getGridCellFactory();

export default {
  name: 'PGE_CMS_00006_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageId: {
      type: String,
      default: 'PGE_CMS_00006',
    },
    programId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      optionCodes: CommonConstants.selectOptions(),
      codes: {
        COD_PRG_FILE_TYPE: [{ key: 'select', label: this.$t('MSG_TXT_SEL') }],
        COD_GRD_USE_YN: [
          { key: ' ', label: this.$t('MSG_TXT_SEL') },
          { key: 'Y', label: 'Yes' },
          { key: 'N', label: 'No' },
        ],
      },
      attachGroupId: 'ATG_CMS_PRGS_COMMON',
      attachDocumentId: '',
      frame1: {
        programId: '',
        programName: '',
        programContents: '',
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_PRG_TYPE: {
            label: '',
            key: '',
          },
          COD_PRG_TECHN: {
            label: '',
            key: '',
          },
          useYn: 'Y',
        },
      },
      count: 0,
      localdata1: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_FILE_NM'),
        datafield: 'fileName',
        createwidget: (row, column, value, htmlElement) => {
          // 텍스트필드
          const componentInstance = gridEditorFactory.createCellTextField(row, column, value, htmlElement, {
            trim: true,
            maxlength: 25,
          }, this.dsFileLst, this.$refs.grdfilelist);
          const instance = componentInstance.getComponentInstance();

          instance.$on('keyup', () => {
            const datasetEventData = utils.clone(componentInstance.dataset.data);
            const rowIndex = componentInstance.getDatasetIndex();
            const datasetEventRowData = datasetEventData[rowIndex];
            const searchFieldNewText = instance.$refs.refInput.value;

            instance.searchFieldOldText = utils.isEmpty(instance.searchFieldOldText)
              ? datasetEventRowData.fileName
              : instance.searchFieldOldText;

            if (utils.isExistSpecialChar(searchFieldNewText)) {
              utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
                componentInstance.dataset.setData(rowIndex, 'fileName', instance.searchFieldOldText);

                this.gridSetFocus(rowIndex, 'fileName');
              });
            } else {
              instance.searchFieldOldText = searchFieldNewText;
            }
          });
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_FPATH'),
        datafield: 'filePath',
        createwidget: (row, column, value, htmlElement) => {
          // 텍스트필드
          const componentInstance = gridEditorFactory.createCellTextField(row, column, value, htmlElement, {
            trim: true,
            maxlength: 100,
          }, this.dsFileLst, this.$refs.grdfilelist);
          const instance = componentInstance.getComponentInstance();

          instance.$on('keyup', () => {
            const datasetEventData = utils.clone(componentInstance.dataset.data);
            const rowIndex = componentInstance.getDatasetIndex();
            const datasetEventRowData = datasetEventData[rowIndex];
            const searchFieldNewText = instance.$refs.refInput.value;
            instance.searchFieldOldText = utils.isEmpty(instance.searchFieldOldText)
              ? datasetEventRowData.filePath
              : instance.searchFieldOldText;

            if (utils.isOnlyKor(searchFieldNewText)) {
              utils.messageBox('warning', this.$t('MSG_ALT_INPUT_KOR'), null, () => {
                componentInstance.dataset.setData(rowIndex, 'filePath', instance.searchFieldOldText);

                this.gridSetFocus(rowIndex, 'filePath');
              });
            } else {
              instance.searchFieldOldText = searchFieldNewText;
            }
          });
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_FILE_TYPE'),
        datafield: 'fileTypeCode',
        width: 100,
        createwidget: (row, column, value, htmlElement) => {
          gridEditorFactory.createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.codes.COD_PRG_FILE_TYPE,
            },
            this.dsFileLst, this.$refs.grdfilelist);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'fileUseYn',
        width: 80,
        createwidget: (row, column, value, htmlElement) => {
          gridEditorFactory.createCellSegmentBox(
            row, column, value, htmlElement, {}, this.dsFileLst, this.$refs.grdfilelist,
          );
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_CNTN'),
        datafield: 'fileContent',
        width: 200,
        createwidget: (row, column, value, htmlElement) => {
          // 텍스트필드
          gridEditorFactory.createCellTextField(row, column, value, htmlElement, {
            trim: true,
            maxlength: 1000,
          }, this.dsFileLst, this.$refs.grdfilelist);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }],
      programIdCheckFlag: false,
      validMessage: '',
      orgProgramId: '',
    };
  },
  datasets: [{
    id: 'dsFileLst',
    type: 'local',
    data: 'localdata1',
    datafields: [{
      name: 'fileName',
      type: 'string',
      map: 'fileName',
    }, {
      name: 'filePath',
      type: 'string',
      map: 'filePath',
    }, {
      name: 'fileTypeCode',
      type: 'string',
      map: 'fileTypeCode',
    }, {
      name: 'fileUseYn',
      type: 'string',
      map: 'fileUseYn',
    }, {
      name: 'fileContent',
      type: 'string',
      map: 'fileContent',
    }],
  }],
  computed: {},
  watch: {},
  mounted() {
    this.loadCode();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadCode() {
      return http.mergeCodeList(this.pageId, CODE_KEYS, this.codes);
    },
    loadData() {},
    onCancelClick() {
      this.$emit('close');
    },
    onPrgIdValidCheck() {
      if (!(this.frame1.programId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRG_ID')));
      } else if (!this.programIdCheckFlag) {
        this.onProgramIdCheck();
      }
    },
    onProgramIdCheck() {
      if (utils.isEngNum_(this.frame1.programId) === false) {
        utils.messageBox('warning', this.$t('MSG_ALT_ONLY_ENGLISH_NUMBER_UNDERBAR'), null, () => {
          this.frame1.programId = '';
          this.$refs.programId.setFocus();
          this.programIdCheckFlag = false;
        });
        return;
      }

      this.orgProgramId = this.frame1.programId;
      const queryParams = {
        programId: this.frame1.programId,
      };
      http.request(this.pageId, 'DTS_CMS_00025', {
        query: queryParams,
      }).then(res => {
        if (!res.data) {
          utils.messageBox('success', this.$t('MSG_ALT_USABLE_PROGRAM_ID'), null, () => {
            this.programIdCheckFlag = true;
          });
        } else {
          utils.messageBox('warning', this.$t('MSG_ALT_DUPLICATE_PROGRAM_ID'), null, () => {
            this.programIdCheckFlag = false;
          });
        }
      }).catch(() => {
        utils.messageBox('warning', this.$t('MSG_ALT_ERR_CONTACT_ADMIN'));
      });
    },
    onSaveClick() {
      const dataParams = {
        moduleCode: utils.trim(this.frame1.selectData.COD_MDLE.key),
        subModuleCode: utils.trim(this.frame1.selectData.COD_SMDLE.key),
        programId: this.frame1.programId,
        programName: this.frame1.programName,
        programTypeCode: utils.trim(this.frame1.selectData.COD_PRG_TYPE.key),
        programTechnCode: utils.trim(this.frame1.selectData.COD_PRG_TECHN.key),
        programUseYn: this.frame1.selectData.useYn,
        programContents: this.frame1.programContents,
        attachGroupId: this.attachGroupId,
      };
      const gridParams = {
        programFileList: this.dsFileLst.data,
      };

      if (this.validation(dataParams)) {
        if (this.programIdCheckFlag) {
          if (this.validationGrid(gridParams)) {
            const fileList = gridParams.programFileList;
            let tmpFileNames = '';
            let tmpFilePaths = '';
            tmpFileNames = utils.map(fileList, 'fileName');
            tmpFilePaths = utils.map(fileList, 'filePath');

            if (fileList.length !== utils.uniq(tmpFileNames).length) {
              utils.messageBox('warning', this.$t('MSG_ALT_DUPLICATE_FILE_NAME'));
            } else if (fileList.length !== utils.uniq(tmpFilePaths).length) {
              utils.messageBox('warning', this.$t('MSG_ALT_DUPLICATE_FILE_PATH'));
            } else {
              this.onSave(dataParams, gridParams);
            }
          }
        } else {
          utils.messageBox('warning', this.$t('MSG_ALT_SELT_DPCT_CHK'));
        }
      } else {
        utils.messageBox('warning', this.validMessage);
      }
    },
    validation(data) {
      let validFlag = true;
      utils.forEach(data, (value, key) => {
        if (utils.isEmpty(value)) {
          validFlag = false;
          switch (key) {
            case 'moduleCode':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE'));
              return false;
            case 'subModuleCode':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE'));
              return false;
            case 'programId':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRG_ID'));
              return false;
            case 'programName':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRG_NM'));
              return false;
            case 'programTypeCode':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PRG_TYPE'));
              return false;
            case 'programTechnCode':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PRG_TECHN'));
              return false;
            case 'programUseYn':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_USE_YN'));
              return false;
            case 'programContents':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PRG_CNTN'));
              return false;
            default:
              this.validMessage = '';
          }
        }
        return null;
      });
      return validFlag;
    },
    validationGrid(gridParams) {
      let validFlag = true;
      utils.forEach(gridParams.programFileList, obj => {
        if (utils.isEmpty(utils.trim(obj.fileName))) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT_FILE_NM'), obj.index));
          validFlag = false;
          return false;
        }
        if (utils.isEmpty(utils.trim(obj.filePath))) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT_FILE_PATH'), obj.index));
          validFlag = false;
          return false;
        }
        if (utils.isEmpty(utils.trim(obj.fileTypeCode)) || utils.trim(obj.fileTypeCode) === 'select') {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_SELECT_FILE_TYPE'), obj.index));
          validFlag = false;
          return false;
        }
        if (utils.isEmpty(utils.trim(obj.fileUseYn))) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_SELECT_USE_YN'), obj.index));
          validFlag = false;
          return false;
        }
        if (utils.isEmpty(utils.trim(obj.fileContent))) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT_CONTENT'), obj.index));
          validFlag = false;
          return false;
        }
        return null;
      });
      return validFlag;
    },
    onSave(dataParams, gridParams) {
      const regParams = {
        moduleCode: dataParams.moduleCode,
        subModuleCode: dataParams.subModuleCode,
        programId: dataParams.programId,
        programName: dataParams.programName,
        programTypeCode: dataParams.programTypeCode,
        programTechnCode: dataParams.programTechnCode,
        programUseYn: dataParams.programUseYn,
        programContents: dataParams.programContents,
        programFileList: gridParams.programFileList,
        attachFileList: this.$refs.fileAttacher.getAttachFileListInfo(),
      };
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMS_00022', {
          data: regParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, this.research);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    research() {
      this.$emit('saveClose');
    },
    onClickAddRow() {
      const defaultRow = [{
        fileName: '',
        filePath: '',
        fileTypeCode: 'select',
        fileUseYn: 'Y',
        fileContent: '',
      }];
      this.dsFileLst.addRows(defaultRow);
    },
    onClickDelRow() {
      const deleteRows = [];
      const selectedIndexes = this.dsFileLst.getSelectedIndexes();

      utils.forEach(selectedIndexes, index => {
        if (utils.isEmpty(this.dsFileLst.data[index].rowType)) {
          deleteRows.push(this.dsFileLst.data[index]);
        }
      });
      this.dsFileLst.deleteRows(selectedIndexes);
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grdfilelist.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grdfilelist.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
    onKeyUpInput() {
      if (this.orgProgramId !== this.frame1.programId) {
        this.programIdCheckFlag = false;
      }
    },
  },
};
</script>
<style scoped>
</style>
